<template>
  <div>
    <template v-if="hideManage">
      <div class="flex flex_gap_5">
        <button v-for="(d,i) in list" v-if="i < 5" class="btn btn-default" type="button" @click="onSelect(d)">
          {{ d }}
        </button>
        <button @click="openEditBlock" class="btn btn-default" type="button">
          <i class="icon-fa icon-fa-edit"/>
        </button>
      </div>
    </template>
    <template v-else>
      <div>
        <div class="mb-3">
          <input type="text" placeholder="Новый ответ для чатов" v-model="newSnippet" class="form-control">
          <div class="text-right mt-1">
            <LoadingButton
              title="Сохранить"
              type="button"
              :loading="btnLoading"
              :color="$constants.LOADING_COLOR"
              :onClick="() => saveSnippet()"
              className="btn btn-outline-info"
            />
          </div>
        </div>
        <div>
          <draggable
            v-model="list"
            tag="div"
            @update="updateOrderList()"
          >
            <transition-group type="transition" name="flip-list">
              <div :key="`btn_${i}`" class="btn-group mb-1 w-100" v-for="(d,i) in list">
                <button class="btn btn-default w-100 text-left" type="button" @click="onSelect(d)">{{ d }}</button>
                <button class="btn btn-outline-danger" type="button" @click="saveSnippet(true, i)"><i
                  class="icon-fa icon-fa-trash-o"/>
                </button>
              </div>
            </transition-group>
          </draggable>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import store from "@/store";
import draggable from "vuedraggable";

export default {
  components: {draggable, LoadingButton},
  props: ['onSelect', 'hideManage'],
  data() {
    return {
      newSnippet: null,
      btnLoading: false,
      list: [],
    }
  },
  watch: {
    $UserDetails: {
      handler: function (val, oldVal) {
        this.updateList();
      }
    }
  },
  created() {
    this.updateList();
  },
  methods: {
    updateList() {
      this.list = this.getSnippetDetail()?.details ?? [];
    },
    updateOrderList() {
      this.saveSnippet(false, null, true);
    },
    getSnippetDetail() {
      return this.$UserDetails.find((d) => d.alias === 'chat_snippets');
    },
    async saveSnippet(toDelete = false, index = null, updateOrder = false) {
      if ((!toDelete && !updateOrder) && !this.newSnippet) return;
      let newData;
      if (updateOrder) {
        newData = [...this.list];
      } else if (!toDelete) {
        this.btnLoading = true;
        newData = [...(this.getSnippetDetail()?.details ?? []), ...[this.newSnippet]];
      } else {
        newData = [...(this.getSnippetDetail()?.details ?? [])];
        delete newData[index];
        newData = newData.filter((d) => d);
      }
      const {data} = await api.post('/new/users/details', {
        action: 'updateDetail',
        detail_id: null,
        alias: 'chat_snippets',
        newData
      })
      if (data.success) {
        this.newSnippet = null;
        const index = this.$UserDetails.findIndex((d) => d.alias === 'chat_snippets');
        this.$UserDetails[index].details = newData;
        store.dispatch('user/setDetails', [...this.$UserDetails]);
      }
      this.btnLoading = false;
    },
    openEditBlock() {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {
          drawer: {small: true},
          type: 'ChatReplySnippets',
        },
        callBackAction: this.onSelect
      });
    }
  }
}

</script>
